import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from '../shared/ui';
import config from '../config/config';
import DashboardScreenNew from '../features/dashboard/ui/DashboardScreenNew';
import OnboardingScreen from '../features/onboarding/ui/OnboardingScreen';
import LoginScreen from '../features/onboarding/ui/LoginScreen';
import RegisterScreen from '../features/onboarding/ui/RegisterScreen';
import ForgotPasswordScreen from '../features/onboarding/ui/ForgotPasswordScreen';
import InviteAcceptPage from '../features/onboarding/ui/InviteAcceptPage';
import PrivacyPolicyPage from '../features/legal/ui/PrivacyPolicyPage';
import TermsOfUsePage from '../features/legal/ui/TermsOfUsePage';
// Fallback значения на случай, если config не загрузился
const FALLBACK_CONFIG = {
  app: {
    loginRoute: '/login'
  }
};

// Используем config или fallback
const currentConfig = config || FALLBACK_CONFIG;

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Публичные маршруты */}
      <Route path="/" element={<OnboardingScreen />} />
      <Route 
        path={currentConfig.app.loginRoute} 
        element={
          <ProtectedRoute requireAuth={false}>
            <LoginScreen />
          </ProtectedRoute>
        } 
      />
      <Route
        path="/register"
        element={
          <ProtectedRoute requireAuth={false}>
            <RegisterScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path="/forgot-password"
        element={
          <ProtectedRoute requireAuth={false}>
            <ForgotPasswordScreen />
          </ProtectedRoute>
        }
      />
      <Route
        path="/invite/:token"
        element={<InviteAcceptPage />}
      />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      <Route path="/terms" element={<TermsOfUsePage />} />
      
      {/* Защищенные маршруты */}
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <DashboardScreenNew />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/dashboard-new" 
        element={
          <ProtectedRoute>
            <DashboardScreenNew />
          </ProtectedRoute>
        } 
      />
      {/* Старые ссылки на профиль — открываем дашборд с вкладкой «Профиль» */}
      <Route 
        path="/profile" 
        element={
          <ProtectedRoute>
            <Navigate to="/dashboard" state={{ tab: 'profile' }} replace />
          </ProtectedRoute>
        } 
      />

    </Routes>
  );
};
